import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { ChevronDown } from "lucide-react";
import { getTutorialVideo } from "../../reducers/analytics.slice";
import useMediaQuery from "../../components/shared/useMediaQuery";

const accordionData = [
  {
    id: "1",
    question: "How do I reset my password?",
    answer: "Go to the login screen and click on 'Forgot Password' to initiate the reset process.",
  },
  {
    id: "2",
    question: "How do I track my order?",
    answer: "You can track your order by visiting our order tracking page and entering your order number.",
  },
  {
    id: "3",
    question: "How do I change my shipping address?",
    answer:
      "To change your shipping address, please log in to your account and update your address information in the 'Shipping Address' section.",
  },
  {
    id: "4",
    question: "How do I contact customer support?",
    answer: "You can reach our customer support team by visiting the 'Contact Us' section on our website.",
  },
];

const FAQPages = () => {
  const [expanded, setExpanded] = useState(null);
  const [videoLink, setVideoLink] = useState("");

  const dispatch = useDispatch();
  const isMobile = useMediaQuery("(max-width: 640px)");

  const handleChange = (id) => {
    setExpanded((prev) => (prev === id ? null : id));
  };

  useEffect(() => {
    getTutorialVideoLink();
  }, []);

  const getTutorialVideoLink = () => {
    dispatch(getTutorialVideo({ tut_id: "faq_1" })).then((res) => {
      if (res?.error && Object.keys(res?.error)?.length > 0) {
        setVideoLink(
          "https://rsc-application-artifacts.s3.amazonaws.com/faq_data/demo.mp4?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIA5FTZENMHAFIJYE7Y%2F20250210%2Fus-east-2%2Fs3%2Faws4_request&X-Amz-Date=20250210T102507Z&X-Amz-Expires=3600&X-Amz-SignedHeaders=host&X-Amz-Signature=691845fc954034684daa8f03abc2bd3999f1437207d3ecc492deea864373ef4a"
        );
        return;
      }
      setVideoLink(res?.payload?.url);
    });
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100%",
      }}
    >
      <div
        style={{
          padding: isMobile ? 16 : 24,
          borderRadius: 10,
          marginBottom: "3rem",
          gap: 16,
          width: "100%",
          maxWidth: 550,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div>
          <h2 style={{ fontSize: "1.3rem", fontWeight: 700, color: "#fff", margin: 0 }}>Help & Support</h2>
          <p style={{ color: "#ffffff85", fontFamily: "Inter", fontWeight: 300, fontSize: "1rem", margin: "4px 0 0" }}>
            Find answers to common questions or reach out to us for further assistance.
          </p>
        </div>

        <div>
          <video
            src={videoLink}
            autoPlay
            controls
            playsInline
            muted
            style={{ height: isMobile ? "min(56vw, 280px)" : 400, width: "100%", maxWidth: "100%", borderRadius: 8 }}
          />
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: 8, marginTop: 12 }}>
          {accordionData.map((item) => (
            <div
              key={item.id}
              style={{
                border: "1px solid rgba(255,255,255,0.08)",
                borderRadius: 8,
                overflow: "hidden",
                background: "rgba(255,255,255,0.02)",
              }}
            >
              <button
                onClick={() => handleChange(item.id)}
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: "12px 16px",
                  background: "transparent",
                  border: "none",
                  cursor: "pointer",
                  color: "#fff",
                  fontSize: 14,
                  textAlign: "left",
                }}
              >
                <span>{item.question}</span>
                <ChevronDown
                  size={16}
                  style={{
                    flexShrink: 0,
                    marginLeft: 8,
                    transform: expanded === item.id ? "rotate(180deg)" : "rotate(0deg)",
                    transition: "transform 0.2s",
                    color: "#8b9296",
                  }}
                />
              </button>
              {expanded === item.id && (
                <div
                  style={{
                    padding: "0 16px 14px",
                    fontSize: 13,
                    color: "#c3c8cc",
                    lineHeight: 1.6,
                  }}
                >
                  {item.answer}
                </div>
              )}
            </div>
          ))}
        </div>

        <div style={{ marginTop: 8 }}>
          <p
            style={{
              color: "#ffffff85",
              fontFamily: "Inter",
              fontWeight: 300,
              fontSize: "1rem",
              textAlign: "center",
              margin: 0,
            }}
          >
            If your issue isn't covered in the FAQs, you can reach out to us through Discord for further assistance.
          </p>
        </div>
      </div>
    </div>
  );
};

export default FAQPages;
